import React from 'react';
import { Route } from 'react-router-dom';
import BhiAdminRoute from 'src/routes/BhiAdminRoute';
import PrivateRoute from 'src/routes/PrivateRoute';
import { AutomationsPage } from '../pages';

export const routes = (
  <Route
    path="/automations"
    element={
      <PrivateRoute>
        <BhiAdminRoute>
          <AutomationsPage />
        </BhiAdminRoute>
      </PrivateRoute>
    }
  />
);
